export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.aprendos.app';

export default function GooglePlayBadge({
  className = '',
  size = 'default',
}) {
  const widthClass = size === 'small' ? 'w-[132px]' : 'w-[156px] sm:w-[168px]';
  const containerClass = size === 'small'
    ? 'min-h-[46px] gap-2.5 rounded-[12px] px-3 py-2'
    : 'min-h-[50px] gap-2 rounded-[12px] px-2.5 py-2.5';
  const iconClass = size === 'small' ? 'h-5 w-5' : 'h-5.5 w-5.5';
  const eyebrowClass = size === 'small'
    ? 'text-[0.52rem] tracking-[0.14em] text-white/80'
    : 'text-[0.54rem] tracking-[0.12em] text-white/80';
  const titleClass = size === 'small'
    ? 'mt-0.5 text-[0.92rem] tracking-[-0.01em]'
    : 'mt-0.5 text-[1rem] tracking-[-0.015em]';

  return (
    <a
      href={GOOGLE_PLAY_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="GET IT ON Google Play"
      className={`inline-flex ${widthClass} transition-transform duration-200 hover:-translate-y-0.5 active:translate-y-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#D63AB4] focus-visible:ring-offset-2 ${className}`}
    >
      <span className={`flex w-full items-center ${containerClass} bg-black text-white`}>
        <svg
          viewBox="0 0 24 24"
          aria-hidden="true"
          className={`${iconClass} shrink-0`}
        >
          <path fill="#00D0FF" d="M3.64 2.27 13.9 12.53 3.64 22.79A2.08 2.08 0 0 1 3 21.29V3.77c0-.57.24-1.09.64-1.5Z" />
          <path fill="#00E676" d="m16.88 15.5-2.98-2.97 2.98-2.98 3.64 2.07c.96.55.96 1.93 0 2.47Z" />
          <path fill="#FFCA28" d="M20.52 12 16.88 9.93 13.9 12.9l2.98 2.98Z" />
          <path fill="#FF5252" d="M3.64 2.27c.06.06.13.11.2.16l13.04 7.5L13.9 12.9Z" />
          <path fill="#FF5252" d="m3.84 22.63 13.04-7.13-2.98-2.97Z" />
        </svg>
        <span className="flex flex-col leading-none">
          <span className={`font-semibold uppercase ${eyebrowClass}`}>
            GET IT ON
          </span>
          <span className={`whitespace-nowrap font-semibold ${titleClass}`}>
            Google Play
          </span>
        </span>
      </span>
    </a>
  );
}
